<template>
  <el-dialog
    v-loading="waitLoading"
        title="参数设置"
        :visible.sync="dialogVisible"
        width="700px"
        :before-close="handleClose"
      >
        <el-form :model="kbxmCsForm" ref="kbxmCsForm" label-width="285px" :disabled="!canSet">
          <el-form-item
            v-for="(item, index) in kbxmCsList"
            :key="index"
            :prop="item.csdm"
            :label="item.csmc"
            :rules="
              /^[a-z]$/g.test(item.csdm)
                ? [{ validator: validateFieldMethods, trigger: 'blur' }]
                : [{ required: true, message: '必填项', trigger: 'blur' }]
            "
          >
            <!-- <el-input oninput="value=value.replace(/[^\d.]/g,'').replace(/^\./g, '')"  v-model="form[item.csdm]" style='width:300px'></el-input> {{item.cshz}} -->
            <template v-if="projectType == 1">
              <el-select
              v-if="item.yzgz == 'select'"
                v-model="kbxmCsForm[item.csdm]"
                style="width: 150px"
                :disabled="item.yzgz == 'draw' && item.jslx == '1'"
              >
              <el-option 
              v-for="a in item.urldz.split(',')"
              :key="a" 
              :label="a" 
              :value="a"></el-option>
              </el-select>
              <el-input
                v-else
                oninput="value=value.replace(/[^\d\.\-0]/g,'').replace(/^\./g, '')"
                v-model="kbxmCsForm[item.csdm]"
                style="width: 150px"
                :disabled="item.yzgz == 'draw' && item.jslx == '1'"
              ></el-input>
            </template>
            
            <template v-else>
              <el-select
              v-if="item.yzgz == 'select'"
                v-model="kbxmCsForm[item.csdm]"
                style="width: 150px"
              >
              <el-option 
              v-for="a in item.urldz.split(',')"
              :key="a" 
              :label="a" 
              :value="a"></el-option>
              </el-select>
              <el-input
                v-else
                v-model="kbxmCsForm[item.csdm]"
                :disabled="item.abled"
                @input="handleInput(item.csdm, kbxmCsForm[item.csdm], item.ball)"
                style="width: 150px"
              ></el-input>
            </template>
            {{ item.cshz }}
            <el-button type="primary" @click="goDrawLots(item)" v-if="projectType == 1 && item.yzgz == 'draw'" :disabled="item.jslx == '1'">抽取参数</el-button>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
          <el-button v-if="canSet" type="primary" @click="handleSubmit">确 定</el-button>
        </span>
      </el-dialog>
</template>

<script>
import ParamSettingMixin from '@/mixins/ParamSettingMixin';
import WebSocketMixin from '@/mixins/WebSocketMixin';

export default {
  mixins: [ParamSettingMixin, WebSocketMixin],

  props: {
    project: {
      type: Object,
      defaut: () => {}
    },
    projectType: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      waitLoading: false,
      dialogVisible: false,
      kbxmCsList: [], // 参数设置列表
      kbxmCsForm: {}, // 参数配置表单
      kbxmCsFormRules: [], // 参数配置校验
    }
  },

  created () {
    this.wsParams = { bdId: this.$route.query.bdId };
  },

  methods: {
    // 重写 WebSocket 消息处理方法
    webSocketMessage(obj) {
      console.log('WebSocket message:', obj);
      let lx = obj.lx;
      if (lx == "tbrRefresh") {
        this.getKbxmCsList();
      }
    },
    goDrawLots(item) {
      // const routeUrl = this.$router.resolve({
      //   path: "/drawLots",
      //   query: {
      //     kbxmCsForm: JSON.stringify(this.kbxmCsForm),
      //     targetKey: item.csdm,
      //   },
      // });
      const beforeName = this.$route.name
      const beforeQuery = this.$route.query
      this.$router.push({
        path: "/drawLots",
        query: {
          kbxmCsForm: JSON.stringify(this.kbxmCsForm),
          targetKey: item.csdm,
          beforeName: beforeName,
          beforeQuery: JSON.stringify(beforeQuery),
        },
      })
      // window.open(routeUrl.href, "_blank"); // 保持路由配置一致性
    },
    async open() {
      await this.getKbxmCsList();
      if (!this.kbxmCsList.length) {
        this.$message({
          type: "warning",
          message: "无需设置参数",
        });
        return;
      }
      this.dialogVisible = true;
    },

    // 关闭利率设置
    handleClose() {
      this.$refs.kbxmCsForm.resetFields();
      this.dialogVisible = false;
    },
    
    handleInput(csdm, cqs, ball) {
      this.kbxmCsForm[csdm] = this.kbxmCsForm[csdm]
        .replace(/[^\d\.\-0]/g, "")
        .replace(/^\./g, "");
      this.setCsdm = csdm;
      this.setCqs = cqs;
      this.setBall = ball;
    },

    handleSubmit() {
      this.$refs.kbxmCsForm.validate((valid) => {
        if (!valid) return;

        this.waitLoading = true;
        this.$api
          .saveSzcs(this.kbxmCsForm)
          .then(res => {
            if (!res.data.meta.success) {
              this.$message({
                type: "error",
                message: res.data.meta.message,
              });
              return;
            }
            this.$message({
              type: "success",
              message: "参数设置保存成功！",
            });
            this.$emit('success');
            this.handleClose();
          }).finally(() => this.waitLoading = false);
      });
    },

    async getKbxmCsList() {
      try {
        const { data } = await this.$api.getKbxmCscqnrForm({});
        if (!data.data.kcList.length) return;

        this.kbxmCsList = data.data.kcList.map(item => ({
          ...item,
          abled: /^[a-z][z]$/g.test(item.csdm),
          ball: /^[a-z]$/g.test(item.csdm) ? 1 : 0
        }));;
        this.kbxmCsForm = { ...data.data.csMap };
        this.kbxmCsFormRules = Object.keys(this.kbxmCsForm);
      } catch(err) {
        console.error('getKbxmCscqnrForm fail', err);
      }
    },
  }
}
</script>

<style scoped lang='scss'>
::v-deep {
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before {
    content: '*';
    color: #d70a30;
    margin-right: 4px;
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>
